export { GEOJSON_PROPERTY } from 'components/Map/hooks/useFeatures/constants';

export const BUFFER_METERS = 15;

export const DEFAULT_PADDING = 100;

export enum LAYER_TYPE {
    FILL = 'fill',
    LINE = 'line',
    SYMBOL = 'symbol',
    CIRCLE = 'circle',
    HEATMAP = 'heatmap',
    FILL_EXTRUSION = 'fill-extrusion',
    BUILDING = 'building',
    RASTER = 'raster',
    RASTER_PARTICLE = 'raster-particle',
    HILLSHADE = 'hillshade',
    MODEL = 'model',
    BACKGROUND = 'background',
    SKY = 'sky',
    SLOT = 'slot',
    CLIP = 'clip'
}
